import React from 'react'

import { Navigate, Route, Routes } from 'react-router-dom'
import PATH from './path'
import {
  adminRoutes,
  agentRoutes,
  directorAgentRoutes,
  directorPlaceRoutes,
  platformRoutes,
  superAdminRoutes,
} from './routes'
import { useAppSelector } from '../redux/types/types'
import PrivateRoute from '../pages/PrivateRoute/PrivateRoute'
import AuthPage from '../pages/AuthPage/AuthPage'
import BlockedPage from '../pages/BlockedPage/BlockedPage'
import RegisterConfirmation from '../pages/RegisterConfirmation/RegisterConfirmation'
import PasswordRecoveryConfirmation from '../pages/PasswordRecoveryConfirmation/PasswordRecoveryConfirmation'
import RegistrationPage from '../pages/RegistrationPage/RegistrationPage'
import PasswordRecoveryPage from '../pages/PasswordRecoveryPage/PasswordRecoveryPage'
import PasswordRecoveryCodePage from '../pages/PasswordRecoveryCodePage/PasswordRecoveryCodePage'
import PasswordRecoverResetPasswordPage from '../pages/PasswordRecoverResetPasswordPage/PasswordRecoverResetPasswordPage'
import ProfilePage from '../pages/ProfilePage/ProfilePage'
import MenuPage from '../pages/MenuPage/menuPage'
import StatsPage from '../pages/StatsPage/StatsPage'
import ClientControlPage from '../pages/ClientControlPage/ClientControlPage'
import ClientsPage from '../pages/ClientPage/ClientPage'
import MainPage from '../pages/MainPage/MainPage'
import BookingPage from '../pages/BookingPage/BookingPage'
import PublicPlaceCard from '../pages/PublicPlaceCard/PublicPlaceCard'

const RouteList = () => {
  let userRole = useAppSelector((state) => state.auth.userRole)

  return (
    <>
      {userRole === 'superAdmin' && (
        <Routes>
          {superAdminRoutes.map((route, index) => (
            <>
              <Route path='/menu-page/:id?' element={<MenuPage />} />
              <Route path={PATH.mainPage} element={<MainPage />} />

              <Route
                key={PATH.clientControlPage}
                path={PATH.clientControlPage}
                element={<ClientControlPage />}
              />
              <Route
                key={route.path}
                path={PATH.clientControlPage}
                element={<ClientControlPage />}
              />
              <Route key={route.path} path={PATH.statsPage} element={<StatsPage />} />
              <Route key={route.path} path={PATH.authPage} element={<AuthPage />} />
              <Route key={route.path} path={PATH.blockedPage} element={<BlockedPage />} />
              <Route
                key={route.path}
                path={PATH.registerConfirmation}
                element={<RegisterConfirmation />}
              />
              <Route
                key={route.path}
                path={PATH.passwordRecoveryConfirmation}
                element={<PasswordRecoveryConfirmation />}
              />
              <Route key={route.path} path={PATH.registrationPage} element={<RegistrationPage />} />
              <Route
                key={route.path}
                path={PATH.passwordRecoveryPage}
                element={<PasswordRecoveryPage />}
              />
              <Route
                key={route.path}
                path={PATH.passwordRecoveryCodePage}
                element={<PasswordRecoveryCodePage />}
              />
              <Route
                key={route.path}
                path={PATH.passwordRecoveryResetPasswordPage}
                element={<PasswordRecoverResetPasswordPage />}
              />
              <Route
                key={index}
                path={route.path}
                element={<PrivateRoute element={route.component} />}
              />
            </>
          ))}
          <Route path='*' element={<Navigate to={PATH.error404} />} />
        </Routes>
      )}
      {userRole === 'admin' && (
        <Routes>
          {adminRoutes.map((route, index) => (
            <>
              <Route path={PATH.mainPage} element={<MainPage />} />
              <Route path={PATH.mainPage} element={<MainPage />} />
              <Route path={PATH.clientControlPage} element={<ClientControlPage />} />
              <Route path='/menu-page/:id?' element={<MenuPage />} />
              <Route path={PATH.authPage} element={<AuthPage />} />
              <Route path={PATH.blockedPage} element={<BlockedPage />} />
              <Route path={PATH.registerConfirmation} element={<RegisterConfirmation />} />
              <Route
                path={PATH.passwordRecoveryConfirmation}
                element={<PasswordRecoveryConfirmation />}
              />
              <Route path={PATH.registrationPage} element={<RegistrationPage />} />
              <Route path={PATH.passwordRecoveryPage} element={<PasswordRecoveryPage />} />
              <Route
                key={route.path}
                path={PATH.passwordRecoveryCodePage}
                element={<PasswordRecoveryCodePage />}
              />
              <Route
                key={route.path}
                path={PATH.passwordRecoveryResetPasswordPage}
                element={<PasswordRecoverResetPasswordPage />}
              />
              <Route
                key={index}
                path={route.path}
                element={<PrivateRoute element={route.component} />}
              />
            </>
          ))}
          <Route path='*' element={<Navigate to={PATH.error404} />} />
        </Routes>
      )}
      {userRole === 'directorAgent' && (
        <Routes>
          <Route path={PATH.mainPage} element={<MainPage />} />
          {directorAgentRoutes.map((route, index) => (
            <>
              <Route path={PATH.clientControlPage} element={<ClientControlPage />} />
              <Route path='/menu-page/:id?' element={<MenuPage />} />
              <Route key={route.path} path={PATH.statsPage} element={<StatsPage />} />
              <Route path={PATH.authPage} element={<AuthPage />} />
              <Route path={PATH.blockedPage} element={<BlockedPage />} />
              <Route path={PATH.registerConfirmation} element={<RegisterConfirmation />} />
              <Route
                path={PATH.passwordRecoveryConfirmation}
                element={<PasswordRecoveryConfirmation />}
              />
              <Route path={PATH.registrationPage} element={<RegistrationPage />} />
              <Route path={PATH.passwordRecoveryPage} element={<PasswordRecoveryPage />} />
              <Route
                key={route.path}
                path={PATH.passwordRecoveryCodePage}
                element={<PasswordRecoveryCodePage />}
              />
              <Route
                key={route.path}
                path={PATH.passwordRecoveryResetPasswordPage}
                element={<PasswordRecoverResetPasswordPage />}
              />
              <Route
                key={index}
                path={route.path}
                element={<PrivateRoute element={route.component} />}
              />
            </>
          ))}
          <Route path='*' element={<Navigate to={PATH.error404} />} />
        </Routes>
      )}
      {userRole === 'directorPlace' && (
        <Routes>
          {directorPlaceRoutes.map((route, index) => (
            <>
              <Route path={PATH.mainPage} element={<MainPage />} />
              <Route path={PATH.clientControlPage} element={<ClientControlPage />} />
              <Route path='/menu-page/:id?' element={<MenuPage />} />
              <Route key={route.path} path={PATH.statsPage} element={<StatsPage />} />
              <Route path={PATH.authPage} element={<AuthPage />} />
              <Route path={PATH.blockedPage} element={<BlockedPage />} />
              <Route path={PATH.registerConfirmation} element={<RegisterConfirmation />} />
              <Route
                path={PATH.passwordRecoveryConfirmation}
                element={<PasswordRecoveryConfirmation />}
              />
              <Route path={PATH.registrationPage} element={<RegistrationPage />} />
              <Route path={PATH.passwordRecoveryPage} element={<PasswordRecoveryPage />} />
              <Route
                key={route.path}
                path={PATH.passwordRecoveryCodePage}
                element={<PasswordRecoveryCodePage />}
              />
              <Route
                key={route.path}
                path={PATH.passwordRecoveryResetPasswordPage}
                element={<PasswordRecoverResetPasswordPage />}
              />
              <Route
                key={index}
                path={route.path}
                element={<PrivateRoute element={route.component} />}
              />
            </>
          ))}
          <Route path='*' element={<Navigate to={PATH.error404} />} />
        </Routes>
      )}
      {userRole === 'employeeAgent' && (
        <Routes>
          {agentRoutes.map((route, index) => (
            <>
              <Route path={PATH.mainPage} element={<MainPage />} />
              <Route path={PATH.clientControlPage} element={<ClientControlPage />} />
              <Route key={route.path} path={PATH.statsPage} element={<StatsPage />} />
              <Route path={PATH.authPage} element={<AuthPage />} />
              <Route path={PATH.blockedPage} element={<BlockedPage />} />
              <Route path={PATH.registerConfirmation} element={<RegisterConfirmation />} />
              <Route
                path={PATH.passwordRecoveryConfirmation}
                element={<PasswordRecoveryConfirmation />}
              />
              <Route path={PATH.registrationPage} element={<RegistrationPage />} />
              <Route path={PATH.passwordRecoveryPage} element={<PasswordRecoveryPage />} />
              <Route
                key={route.path}
                path={PATH.passwordRecoveryCodePage}
                element={<PasswordRecoveryCodePage />}
              />
              <Route
                key={route.path}
                path={PATH.passwordRecoveryResetPasswordPage}
                element={<PasswordRecoverResetPasswordPage />}
              />
              <Route
                key={index}
                path={route.path}
                element={<PrivateRoute element={route.component} />}
              />
            </>
          ))}
          <Route path='*' element={<Navigate to={PATH.error404} />} />
        </Routes>
      )}
      {userRole === 'employeePlace' && (
        <Routes>
          {platformRoutes.map((route, index) => (
            <>
              <Route path={PATH.mainPage} element={<MainPage />} />
              <Route path={PATH.clientControlPage} element={<ClientControlPage />} />
              <Route path='/menu-page/:id?' element={<MenuPage />} />
              <Route key={route.path} path={PATH.statsPage} element={<StatsPage />} />
              <Route path={PATH.authPage} element={<AuthPage />} />
              <Route path={PATH.blockedPage} element={<BlockedPage />} />
              <Route path={PATH.registerConfirmation} element={<RegisterConfirmation />} />
              <Route
                path={PATH.passwordRecoveryConfirmation}
                element={<PasswordRecoveryConfirmation />}
              />
              <Route path={PATH.registrationPage} element={<RegistrationPage />} />
              <Route path={PATH.passwordRecoveryPage} element={<PasswordRecoveryPage />} />
              <Route
                key={route.path}
                path={PATH.passwordRecoveryCodePage}
                element={<PasswordRecoveryCodePage />}
              />
              <Route
                key={route.path}
                path={PATH.passwordRecoveryResetPasswordPage}
                element={<PasswordRecoverResetPasswordPage />}
              />
              <Route
                key={index}
                path={route.path}
                element={<PrivateRoute element={route.component} />}
              />
            </>
          ))}
          <Route path='*' element={<Navigate to={PATH.error404} />} />
        </Routes>
      )}
      {userRole === 'public' && (
        <Routes>
          <Route path={'/public-place-card/:id'} element={<PublicPlaceCard />} />
          <Route path={PATH.mainPage} element={<MainPage />} />
          <Route key={PATH.authPage} path={PATH.authPage} element={<AuthPage />} />
          <Route path={PATH.bookingPage} element={<BookingPage />} />
          <Route path='*' element={<Navigate to={PATH.error404} />} />
          <Route path={PATH.registerConfirmation} element={<RegisterConfirmation />} />
          <Route
            path={PATH.passwordRecoveryConfirmation}
            element={<PasswordRecoveryConfirmation />}
          />
          <Route path={PATH.registrationPage} element={<RegistrationPage />} />
          <Route path={PATH.passwordRecoveryPage} element={<PasswordRecoveryPage />} />
          <Route path={PATH.passwordRecoveryCodePage} element={<PasswordRecoveryCodePage />} />
          <Route
            path={PATH.passwordRecoveryResetPasswordPage}
            element={<PasswordRecoverResetPasswordPage />}
          />
        </Routes>
      )}
    </>
  )
}

export default RouteList
